import { Link } from "react-router-dom";
import { Search, FolderOpen, FileText, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  type?: "search" | "category" | "articles";
  title?: string;
  description?: string;
  showCTA?: boolean;
  ctaText?: string;
  ctaLink?: string;
}

export function EmptyState({
  type = "articles",
  title,
  description,
  showCTA = true,
  ctaText = "Gå til forsiden",
  ctaLink = "/",
}: EmptyStateProps) {
  const configs = {
    search: {
      icon: Search,
      defaultTitle: "Ingen resultater fundet",
      defaultDescription: "Prøv at søge efter noget andet, eller udforsk vores kategorier.",
    },
    category: {
      icon: FolderOpen,
      defaultTitle: "Ingen artikler i denne kategori",
      defaultDescription: "Der er endnu ingen artikler i denne kategori. Kom tilbage snart!",
    },
    articles: {
      icon: FileText,
      defaultTitle: "Ingen artikler fundet",
      defaultDescription: "Der er ingen artikler at vise lige nu.",
    },
  };

  const config = configs[type];
  const Icon = config.icon;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-6">
        <Icon className="w-10 h-10 text-muted-foreground" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {title || config.defaultTitle}
      </h3>
      <p className="text-muted-foreground max-w-md mb-6">
        {description || config.defaultDescription}
      </p>
      {showCTA && (
        <Button asChild variant="outline" className="gap-2">
          <Link to={ctaLink}>
            {ctaText}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
